<!--充值返利组件-->
<template>
  <my-modal
      class="recharge-rebate-modal"
      :visible="visible"
      :z-index="1001"
      @close="close">
    <template #cuscloseIcon>
      <!--      <img src="@/assets/images/systemicon/closegray.png" alt=""/>-->
    </template>
    <template #body>
      <div class="rechargeRebate recharge-modal">
        <div class="msg">
          <div class="title">{{$t("rebateTitle1")}}</div>
          <div class="info">{{$t("rebateTitle2")}}</div>
          <div class="bonus-txt balance">{{ rebate.rebate_amount }}</div>
        </div>
        <a-button :disabled="rebate.is_use==='n'" class="get-bonus-btn" @click="handleBonus">{{$t("claim")}}</a-button>
      </div>
    </template>
  </my-modal>
</template>
<script setup>
import {ref, getCurrentInstance} from 'vue'
import showNotice from "@/components/common/notice/notice.js";
import $api from "@/api/index.js";

const {proxy} = getCurrentInstance();
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  rebate: {
    type: Object,
    default: {},
  }
})
const emits = defineEmits(['close'])

console.log('gggprops;', props)

function handleBonus() {
  console.log('弹返利大弹框')
  $api.user.getRebate().then(res => {
    if (res.code === 200) {
      showNotice("s", {desc: res.message});
      //关闭充值弹框
      close();
      proxy.$EventBus.emit("upd", {
        type: "increment",
        val: parseFloat(props.rebate.rebate_amount),
        paytype: "refund",
      });
    } else {
      showNotice("f", {
        desc: res.message,
      });
    }
  })
}

function close() {
  console.log('close')
  emits("close")
}

</script>


<style scoped lang="scss">
.recharge-rebate-modal {
  :deep(.ant-modal) {
    width: max-content !important;

    .ant-modal-close-x {
      position: absolute;
      top: .8rem;
      right: 0rem;

      img {
        width: 0.16rem;
      }
    }

    .ant-modal-content {
      background-color: transparent;
    }
  }
}

.rechargeRebate {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  background-image: url('@/assets/images/event/rechargeRebate/rechargeRebateModal.png');
  overflow: visible;
}

.recharge-modal {
  display: flex;
  width: 4.7rem;
  height: 6.1rem;

  .msg {
    margin-top: 60%;
    width: 100%;
    display: flex;
    flex-direction: column;

    .title, .info, .bonus-txt {
      text-align: center;
    }

    .title {
      margin-top: 4%;
      font-weight: bold;
      font-size: .3rem;
      color: #FFFFFF;
    }

    .info {
      margin-top: .09rem;
      margin-bottom: .18rem;
      font-weight: 400;
      font-size: .2rem;
      color: #F7CFBC;
    }

    .bonus-txt {
      font-weight: bold;
      font-size: .44rem;
      color: #EDD669;
    }
  }

  .get-bonus-btn {
    width: 3.1rem;
    height: .54rem;
    background: linear-gradient(0deg, #FFA914 0%, #CC6600 100%);
    border-radius: .05rem;
    position: absolute;
    left: 50%;
    bottom: 6%;
    transform: translateX(-50%);
    @extend %flex-all-center;
    font-weight: bold;
    font-size: .24rem;
    color: #FFFFFF;
    &:disabled {
      background: linear-gradient(0deg, #856647 0%, #ad9367 100%);
      color:#cccccc;
      //background-color: #191D2F;
      //color: #3B3F50;
       //opacity: .3;
    }
  }
}
</style>